import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListQueryParameters, ISnListResponse } from '@lib/api';
import { SnSearchRmsItem } from '@lib/api/entities';

@Injectable({ providedIn: 'root' })
export class Mark43Service {
  constructor(private readonly _httpClient: HttpClient) {}

  public getRmsSearches(
    params?: ISnListQueryParameters,
  ): Observable<ISnListResponse<SnSearchRmsItem>> {
    return this._httpClient.get('/api/rms/search/', { params }).pipe(
      map((response: ISnListResponse<Partial<SnSearchRmsItem>>) => ({
        links: response.links,
        count: response.count,
        totalPages: response.totalPages,
        results: response.results.map((share) => new SnSearchRmsItem(share)),
      })),
    );
  }

  public getRmsSearchItem(id: string): Observable<SnSearchRmsItem> {
    return this._httpClient
      .get(`/api/rms/search/${id}/`)
      .pipe(map((response: SnSearchRmsItem) => new SnSearchRmsItem(response)));
  }
}
